var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { "label-position": "top", "label-width": "90px" } },
        [
          _vm.setType === "base"
            ? _c(
                "div",
                { staticClass: "option" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "user-type",
                      attrs: { label: "请选择该节点的抄送人", prop: "text" },
                    },
                    [
                      _c("div", { staticClass: "radio-sub-name" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("常用抄送人"),
                        ]),
                        _c("div", { staticClass: "name" }, [_vm._v("主管")]),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group",
                          on: {
                            change: function ($event) {
                              return _vm.changeAssignedType(
                                _vm.nodeProps.assignedType
                              )
                            },
                          },
                          model: {
                            value: _vm.nodeProps.assignedType,
                            callback: function ($$v) {
                              _vm.$set(_vm.nodeProps, "assignedType", $$v)
                            },
                            expression: "nodeProps.assignedType",
                          },
                        },
                        _vm._l(_vm.approvalTypes, function (t, index) {
                          return _c(
                            "el-radio",
                            {
                              key: t.type,
                              class: "radio-" + index,
                              attrs: { label: t.type },
                            },
                            [
                              _c("span", { staticClass: "radio-name" }, [
                                _vm._v(_vm._s(t.name)),
                              ]),
                            ]
                          )
                        }),
                        1
                      ),
                      _vm.nodeProps.assignedType === "ASSIGN_USER"
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-u",
                                  attrs: {
                                    "value-key": "name",
                                    placeholder: "指定成员",
                                    size: "medium",
                                    multiple: "",
                                    "popper-class": "hidden",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.selectUser.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.nodeProps.assignedUser,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.nodeProps,
                                        "assignedUser",
                                        $$v
                                      )
                                    },
                                    expression: "nodeProps.assignedUser",
                                  },
                                },
                                _vm._l(
                                  _vm.nodeProps.assignedUser,
                                  function (wc, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: wc.name, value: wc },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm.nodeProps.assignedType === "LEADER"
                        ? _c("div", [
                            _c("span", { staticClass: "item-desc" }, [
                              _vm._v("发起人直接上级将作为抄送人进行抄送"),
                            ]),
                          ])
                        : _vm.nodeProps.assignedType === "DEPT_LEADER"
                        ? _c("div", [
                            _c(
                              "span",
                              { staticClass: "item-desc" },
                              [
                                _vm._v("发起人的 "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "select-level",
                                    attrs: { size: "small" },
                                    model: {
                                      value: _vm.nodeProps.leader.level,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.nodeProps.leader,
                                          "level",
                                          $$v
                                        )
                                      },
                                      expression: "nodeProps.leader.level",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "第2级主管", value: 2 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "第3级主管", value: 3 },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm.nodeProps.assignedType === "ROLE"
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-u",
                                  attrs: {
                                    "value-key": "name",
                                    placeholder: "指定角色",
                                    size: "medium",
                                    multiple: "",
                                    "popper-class": "hidden",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.selectRole.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.nodeProps.role,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.nodeProps, "role", $$v)
                                    },
                                    expression: "nodeProps.role",
                                  },
                                },
                                _vm._l(
                                  _vm.nodeProps.role,
                                  function (wc, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: wc.name, value: wc },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.setType === "pro"
            ? _c("div", { staticClass: "option" }, [
                _c(
                  "div",
                  { staticClass: "user-type-switch" },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v("允许发起人添加抄送人"),
                    ]),
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#00B498",
                        "inactive-color": "#E4F7F4",
                      },
                      model: {
                        value: _vm.config.shouldAdd,
                        callback: function ($$v) {
                          _vm.$set(_vm.config, "shouldAdd", $$v)
                        },
                        expression: "config.shouldAdd",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "tips" }, [
                  _vm._v("开启后，发起人可自行添加抄送人。"),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: _vm.pickerTitle, multiple: "" },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }